// Google sign-in must work from any wholesaler's custom domain (white-label
// storefronts), but Google OAuth only allows pre-registered origins/redirect
// URIs — it can't be registered per wholesaler domain on the fly. So every
// site opens this same bridge page (always on admin.cresivox.com, the one
// registered origin) in a popup; Google auth happens there, and the resulting
// auth-code is relayed back to the calling page via postMessage.
const BRIDGE_ORIGIN =
  process.env.NODE_ENV === 'production' ? 'https://admin.cresivox.com' : window.location.origin;

export const googleOAuthBridgeLogin = (): Promise<{ code: string } | null> => {
  return new Promise((resolve) => {
    const popup = window.open(
      `${BRIDGE_ORIGIN}/auth/google-bridge?o=${encodeURIComponent(window.location.origin)}`,
      'google-oauth',
      'width=480,height=600,menubar=no,toolbar=no,status=no'
    );

    if (!popup) {
      resolve(null);
      return;
    }

    let settled = false;
    const cleanup = () => {
      window.removeEventListener('message', onMessage);
      clearInterval(closeCheck);
    };

    const onMessage = (event: MessageEvent) => {
      if (event.origin !== BRIDGE_ORIGIN) return;
      if (event.data?.type === 'google-oauth-code') {
        settled = true;
        cleanup();
        resolve(event.data.code ? { code: event.data.code } : null);
      } else if (event.data?.type === 'google-oauth-error') {
        settled = true;
        cleanup();
        resolve(null);
      }
    };

    const closeCheck = setInterval(() => {
      if (popup.closed) {
        cleanup();
        if (!settled) resolve(null);
      }
    }, 500);

    window.addEventListener('message', onMessage);
  });
};
